import React, { createContext, useContext } from 'react';
import { FieldPermission } from '../../forms';

type CustomFieldName = `CF${string} (${string})`;

export interface SmartFormPermissionData {
  user: boolean;
  permissionName: FieldPermission['PERMISSION_NAME'] | CustomFieldName;
  permissionType: 'READ' | 'UPDATE';
  resourceUid?: string;
  isRedirected: boolean;
  canViewPolicyDetails?: boolean;
  canViewPolicyAnalyser?: boolean;
  policyDecision?: any;
}

type SmartFormPermissionContextType = {
  getPolicy(
    resourceUid: string | undefined,
    permission:
      | (Omit<FieldPermission, 'PERMISSION_NAME'> & {
          PERMISSION_NAME?: FieldPermission['PERMISSION_NAME'] | CustomFieldName;
        })
      | undefined
  ): void;
  hasPolicy: boolean;
  canViewPolicyDetails?: boolean;
  canViewPolicyAnalyser?: boolean;
  policyDecision?: any;
  loading: boolean;
  goToPolicyVisualizer(data: SmartFormPermissionData): void;
  goToPolicyDetails(policyUid: string): void;
};

const SmartFormPermissionContext = createContext<SmartFormPermissionContextType | undefined>(undefined);

export const SmartFormPermissionProvider: React.FC<{ children: React.ReactNode } & SmartFormPermissionContextType> = ({
  children,
  ...props
}) => {
  return <SmartFormPermissionContext.Provider value={props}>{children}</SmartFormPermissionContext.Provider>;
};

export const useSmartFormPermissionContext = () => {
  const context = useContext(SmartFormPermissionContext);
  if (!context) throw new Error('useSmartFormPermissionContext must be used within SmartFormPermissionProvider');
  return context;
};
